import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components/macro';
import { SignOutButton } from '../../pages/LoginPage/components/LogoutButton';
import { useSelector } from 'react-redux';
import { selectUsername } from '../../pages/WorkListPage/slice/selectors';
import { stringAvatar } from '../../../styles/StyleConstants';

export default function UserMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const username = useSelector(selectUsername);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Wrapper>
      {username &&
      <React.Fragment>
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          <Avatar className='user-icon' {...stringAvatar(username, 30, 14)} />
          {username}
        </Box>
        <Menu
          anchorEl={anchorEl}
          id='user-menu'
          open={open}
          disableScrollLock={true}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible !important',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              backgroundColor: 'rgba(25, 45, 62, 1) !important',
              border: 'solid white 1px',
              marginTop: '0',
              marginLeft: '5px',
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: -1,
                right: 14,
                width: 10,
                height: 10,
                borderTop: 'solid white 1px',
                borderLeft: 'solid white 1px',
                backgroundColor: 'rgba(25, 45, 62, 1)',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 999,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem>
            <SignOutButton />
          </MenuItem>
        </Menu>
      </React.Fragment>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: ${p => p.theme.primary};

  .user-icon {
    margin-right: 5px;
  }
  .MuiIconButton-root {
    color: white;
    font-size: 14px;
  }
`;
